module.exports = __webpack_public_path__ + "static/media/services_grey.c6b08117.svg";